export const getNumbers = (min, max) => [...Array(max - min + 1).keys()].map(i => i + min);